import * as React from "react";
const SvgEvaArrowIosBackFill = (props) => (
  <svg
    width={32}
    height={32}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <path
      d="M15.127 10.313a.836.836 0 0 1 .652.31l4.031 5.007a.835.835 0 0 1 0 1.06l-4.173 5.008a.836.836 0 0 1-1.286-1.068l3.731-4.474-3.606-4.474a.834.834 0 0 1 .651-1.369Z"
      fill="#000"
      fillOpacity={0.4}
    />
  </svg>
);
export default SvgEvaArrowIosBackFill;
